// @flow
//eslint-disable-next-line
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useTranslation } from '../../../hooks'
import { ARRAY_ROUTE_CONSTANTS, HELPER, HISTORY, PRODUCT_HELPER } from '../../../utils'

function ProceedToCheckout() {
	const translate = useTranslation()

	const { currency_code } = useSelector((state) => state.config.merchant)
	const { cart_items } = useSelector((state) => state.cart)
	const { catalog_cart_items } = useSelector((state) => state.config.catalog_journey_settings)
	const { allProducts } = useSelector((state) => state.inventory)
	const { catalogue_key, custom_catalog } = useSelector((state) => state.config)

	useEffect(() => {
		/*
          UPDATE CART ITEMS
        */
		if (
			Object.keys(catalog_cart_items).length === 0 &&
			parseInt(cart_items.count) === 0 &&
			parseInt(cart_items?.sub_total_amount) === 0 &&
			ARRAY_ROUTE_CONSTANTS.includes(HISTORY.location.pathname) &&
			!HELPER.isEmpty(allProducts)
		) {
			if (!HELPER.isEmpty(catalogue_key) && !custom_catalog) {
				HISTORY.push('/' + catalogue_key)
			} else {
				HISTORY.goBack()
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cart_items])

	return (
		<>
			{/* Cart Total Count */}
			{cart_items?.count > 0 ? (
				<div className="proceedToCheckout">
					<div className="container">
						<div className="proceedToCheckoutContainer">
							<div className="insideProceedToCheckoutContainer">
								<div className="shopCartTotal">
									<span>{translate('CART.TOTAL')}</span>
									<span>
										{HELPER.formatPrice(currency_code, cart_items?.sub_total_amount).default}
									</span>
								</div>
								<button
									onClick={() => PRODUCT_HELPER.PROCEED_TO_CHECKOUT()}
									className="blueSubmitBtn"
								>
									{translate('CART.CHECKOUT_PROCEED')}
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	)
}

export default ProceedToCheckout
